import {getDateFormattedForRestURL} from 'common/utils/date-util';

export default function (params) {
  const args = [`name=${params.meter}`];
  if (params.integrate) {
    args.push(`integrate=${params.integrate}`);
  }

  if (params.resolution) {
    args.push(`resolution=${params.resolution}`);
  }

  if (params.page) {
    args.push(`page=${params.page}`);
  }

  if (params.format) {
    args.push(`format=${params.format}`);
  }

  if (params.start && params.end) {
    const start = getDateFormattedForRestURL(params.start);
    const end = getDateFormattedForRestURL(params.end);
    args.push(`start=${start}`);
    args.push(`end=${end}`);
  } else {
    args.push(`period=${params.period}`);
  }
  if (params.baselineID) {
    args.push(`baseline_id=${params.baselineID}`);
  }

  return `${params.restHost}/reports/timeseries/?${args.join('&')}`;
}
